import { FormControl, Validators } from '@angular/forms';
import { getPattern } from './get-pattern';

export const getFormControl = (key: string, initialValue: unknown = undefined): FormControl => {
  if (key === 'email') {
    return new FormControl(
      initialValue || '',
      Validators.compose([Validators.required, Validators.pattern(getPattern('email'))])
    );
  }
  if (key === 'emailOptional') {
    return new FormControl(initialValue || '', Validators.pattern(getPattern('email')));
  }
  if (key === 'websiteOptional') {
    return new FormControl(initialValue || '', Validators.pattern(getPattern('website')));
  }
  if (key === 'externalUrl') {
    return new FormControl(initialValue || '', Validators.pattern(getPattern('externalUrl')));
  }
  if (key === 'externalUrlOrMailto') {
    return new FormControl(initialValue || '', Validators.pattern(getPattern('externalUrlOrMailto')));
  }
  if (key === 'phoneOptional') {
    return new FormControl(initialValue || '', Validators.pattern(getPattern('phone')));
  }
  if (key === 'password') {
    return new FormControl(
      initialValue || '',
      Validators.compose([Validators.required, Validators.minLength(8)]) // Validators.pattern(getPattern('password')),
    );
  }
  if (key === 'gallery-password') {
    return new FormControl(initialValue || '', Validators.compose([Validators.required]));
  }
  if (key === 'businessName') {
    return new FormControl(initialValue || '', Validators.compose([Validators.maxLength(32)]));
  }
  if (key === 'city') {
    return new FormControl(initialValue || '', Validators.compose([Validators.required]));
  }
  if (key === 'name') {
    return new FormControl(initialValue || '', Validators.compose([Validators.required, Validators.maxLength(64)]));
  }
  if (key === 'country') {
    return new FormControl(initialValue || '', Validators.compose([Validators.required]));
  }
  if (key === 'path') {
    return new FormControl(
      initialValue || '',
      Validators.compose([
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(32),
        Validators.pattern(getPattern('path')),
      ])
    );
  }
  if (key === 'galleryPath') {
    return new FormControl(
      initialValue || '',
      Validators.compose([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(32),
        Validators.pattern(getPattern('galleryPath')),
      ])
    );
  }
  if (key === 'googleAnalyticsTrackingId') {
    return new FormControl(
      initialValue || '',
      Validators.compose([Validators.required, Validators.pattern(getPattern('googleAnalyticsTrackingId'))])
    );
  }

  if (key === 'approval-limit') {
    return new FormControl(
      initialValue || '',
      Validators.compose([Validators.required, Validators.min(1), Validators.pattern(getPattern('approval-limit'))])
    );
  }

  if (key === 'customLabel') {
    return new FormControl(
      initialValue || '',
      Validators.compose([Validators.required, Validators.min(1), Validators.maxLength(16)])
    );
  }

  if (key === 'customDomain') {
    return new FormControl(
      initialValue || '',
      Validators.compose([Validators.required, Validators.min(3), Validators.pattern(getPattern('custom-domain'))])
    );
  }

  console.warn('key not found:', key);
};
